module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Cadastrar', {
    attrs: {
      "showForm": _vm.showFormCadastro,
      "parent": this
    }
  }), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card",
      "editable": _vm.orcamentos.length > 0
    },
    on: {
      "tab-remove": _vm.handleTabsDelete
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-listar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Orçamentos Cadastrados\n\t\t\t")]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Gerar Novo Orçamento",
      "onRegister": (this.validarPermissao(577) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatOrcamento,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1), _vm._v(" "), _vm._l((_vm.orcamentos), function(orcamento, i) {
    return _c('el-tab-pane', {
      key: i,
      attrs: {
        "label": "Config",
        "name": 'tab-editar-' + i
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v(" Editar Orçamento " + _vm._s(orcamento.codigo) + "\n\t\t\t")]), _vm._v(" "), _c('Editar', {
      attrs: {
        "showForm": _vm.showFormEdit,
        "parent": this,
        "orcamento": orcamento
      }
    })], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4333259a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/orcamento/index.vue
// module id = 1488
// module chunks = 45